<template>
  <v-card dark class="text-body-2">
    <div class="pa-3">
      <div>Pre-pay for discounted Ellacard credit</div>
      <v-radio-group dense hide-details :value="value" @change="v => $emit('input', v)">
        <v-radio label="None" :value="null">
          <template v-slot:label>
            <div class="text-body-2 white--text">None</div>
          </template>
        </v-radio>
        <v-radio value="20.00">
          <template v-slot:label>
            <div class="text-body-2 white--text">$20 of credit</div>
            <v-chip class="ml-2 px-2" label outlined small color="red">10% off</v-chip>
          </template>
        </v-radio>
        <v-radio value="50.00">
          <template v-slot:label>
            <div class="text-body-2 white--text">$50 of credit</div>
            <v-chip class="ml-2 px-2" label outlined small color="red">20% off</v-chip>
          </template>
        </v-radio>
        <v-radio value="100.00">
          <template v-slot:label>
            <div class="text-body-2 white--text">$100 of credit</div>
            <v-chip class="ml-2 px-2" label outlined small color="red">30% off</v-chip>
          </template>
        </v-radio>
      </v-radio-group>
    </div>

    <v-divider class="my-2" />

    <div class="pa-3 text-body-2">Or subscribe for more discounts</div>
    <v-list class="py-0 mb-3" dense>
      <v-list-item :to="{ name: 'pricing', hash: '#subscriptions' }">
        Individual
        <v-spacer />
        <price class="mx-2" color="white" value="40" per="year" />
        <v-icon v-html="mdiChevronRight" />
      </v-list-item>
      <v-list-item :to="{ name: 'pricing', hash: '#subscriptions' }">
        Business
        <v-spacer />
        <price class="mx-2" color="white" value="60+" per="year" />
        <v-icon v-html="mdiChevronRight" />
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import Price from '@/components/Price.vue';
import { mdiChevronRight } from '@mdi/js';

export default {
  name: 'credit-packs-card',

  components: {
    Price
  },

  props: [ 'value' ],

  created() {
    Object.assign(this, { mdiChevronRight });
  }
}
</script>
